import { DataGrid } from "@mui/x-data-grid"
import { StaffAttendanceProps } from "../types"
import { getStaffAttendanceColumns } from "../utils/staffAttendanceColumns"
import CustomDataGridToolbar from "../../common/components/CustomDataGridToolbar"
import { dataGridSx } from "../../common/styled/DataGrid"
import pallet from "../../../layouts/pallet"
import { PaperWrapper } from "../../common/styled"

const StaffAttendanceTable = ({ staffAttendanceData, onEdit, loading, searchDate }: StaffAttendanceProps) => {

  const staffAttendanceColumns = getStaffAttendanceColumns(onEdit, searchDate)

  return (
    <PaperWrapper>
      <DataGrid
        loading={loading}
        rows={staffAttendanceData}
        getRowId={(row) => row.userId}
        columns={staffAttendanceColumns}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25, 100]}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PaperWrapper>
  )
}

export default StaffAttendanceTable